import React from "react";


import { ReactSVG } from "react-svg";


import "./index.scss";


type CardRoundIconOrNumberComponentProps = {
    type?: 'svg' | 'text';
    content?: string;
    size?: "auto";
    noBackground?: boolean;
    className?: string;
};


export const CardRoundIconOrNumberComponent:React.FC<CardRoundIconOrNumberComponentProps> = ({
    type, content, size, noBackground, className
}) => {

    if (!type || !content) {
        return null;
    }

    let Component = null;

    const classNames = ['card-component__round-icon-or-number-element'];

    if (className) {
        classNames.push(className);
    }
    if (size) {
        classNames.push(`size-${size}-element`);
    }
    if (noBackground) {
        classNames.push(`no-background-element`);
    }

    switch (type) {
        case 'svg':
            Component = <ReactSVG src={content} wrapper={'span'} className={classNames.join(' ')} />;
            break;
        case 'text':
            Component = <span className={classNames.join(' ')}>{content}</span>
            break;
        default:
            return null;
    }

    return Component;

};


export default CardRoundIconOrNumberComponent;
